// update state
const setCurrentThemeAction = (payload) => {
    return {
        type: "THEMENAME",
        payload
    }
}
export default setCurrentThemeAction;


// WEBPACK FOOTER //
// ./src/actions/setCurrentThemeAction.js